import SEO, { pageSEO } from "../components/seo.component";

export default function Calculator() {
  const seoConfig = pageSEO.calculator();
  return (
    <>
      <SEO {...seoConfig} />
      <div className="container py-12 pt-[180px]">
        <h1 className="text-4xl text-black uppercase tracking-wider font-semibold pb-4">Mortgage Calculator</h1>
        <span className="text-med-grey font-semibold text-xl tracking-wide">
          Find a price range that works with your budget by using our Mortgage
          Calculator
        </span>
      </div>
      <iframe
        src="https://www.mortgagecalculator.org/webmasters/?downpayment=80000&homevalue=400000&loanamount=320000&interestrate=7&loanterm=30&propertytax=2700&pmi=1&homeinsurance=1500&monthlyhoa=0"
        scrolling="no"
        className="w-full h-[2400px] md:h-[1200px] border-0"
      ></iframe>
      {/* <div style={{ fontFamily: 'Arial', height: '36px', top: '-36px', padding: '0 8px 0 0', boxSizing: 'border-box', textAlign: 'right', background: '#f6f9f9', border: '1px solid #ccc', color: '#868686', lineHeight: '34px', fontSize: '12px', position: 'relative' }}>
                </div> */}
    </>
  );
}
